import { render, staticRenderFns } from "./dashboard-card.vue?vue&type=template&id=31d2232d&"
import script from "./dashboard-card.vue?vue&type=script&lang=js&"
export * from "./dashboard-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports